var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubscriber(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 273,
    height: 120,
    viewBox: "0 0 273 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 21.044V120H273V41.0583C259.713 41.0583 261.377 74.3511 238.951 74.3511C217.814 74.3725 228.968 0 196.56 0C165.065 0 175.376 84.7122 143.155 85.4201C114.332 86.0422 122.534 45.7347 101.467 45.7347C80.4003 45.7347 84.876 73.2571 58.6306 73.2571C32.3851 73.2571 30.3932 21.044 0 21.044Z",
    fill: "url(#paint0_linear_2010_1351)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2010_1351",
    x1: 136.506,
    y1: 117.65,
    x2: 136.506,
    y2: -12.7427,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0E31C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0813,
    stopColor: "#E3E527"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5036,
    stopColor: "#EFEC5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.823,
    stopColor: "#F7F079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAF285"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscriber);
export default __webpack_public_path__ + "static/media/subscriber.ce1e4a4bc939688d88356c1755abb399.svg";
export { ForwardRef as ReactComponent };